@if(error) {
  <div class="alert alert-danger">
    <strong>Error:</strong> {{ error }}
    <button class="btn btn-sm btn-secondary ml-2" (click)="refreshRids()">
      Retry
    </button>
  </div>
}

<div>
  <div class="span9">
    <h1 data-automation-name="ridIndex">RIDs</h1>
  </div>
  <p class="lead">
    RIDs are data streams for use in reporting. Each RID contains information about the data stream's sampling rate,
    power information, and market context. RIDs may be assigned to many Metadata reports and Registered reports.
    RIDs' MRIDs are the raw meter names that contribute intervals to the RID.
    Venway does not store the interval values, and instead relies on the Interval Storage Service to store the specific values.
  </p>
</div>

<div class="span3" style="text-align:right; margin-bottom: 10px;">
  <a id="createRid" class="btn btn-large btn-primary" (click)="nextPage($event, '/createRid', router)" style="margin-top:9px; margin-right: 5px;"> Create Rid</a>
  <a id="importRid" class="btn btn-large btn-primary" (click)="nextPage($event, '/importRid', router)" style="margin-top:9px;"> Import Rids</a>
</div>

@if(isLoading) {
  <div class="text-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p>Loading RIDs...</p>
  </div>
}
@else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>ID</th>
      <th>External ID</th>
      <th>Data Source</th>
      <th>Market Context</th>
      <th>Resource</th>
      <th>Minimum Sample Rate</th>
      <th>Maximum Sample Rate</th>
      <th>Power type</th>
      <th># MRIDs</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="External ID" class="input-sm form-control" type="search" [(ngModel)]="externalIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Data Source" class="input-sm form-control" type="search" [(ngModel)]="dataSourceSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Market Context" class="input-sm form-control" type="search" [(ngModel)]="marketContextSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Resource ID" class="input-sm form-control" type="search" [(ngModel)]="resourceIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Min Sample Rate" class="input-sm form-control" type="search" [(ngModel)]="sampleRateMinSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Max Sample Rate" class="input-sm form-control" type="search" [(ngModel)]="sampleRateMaxSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="PT Label" class="input-sm form-control" type="search" [(ngModel)]="powerTypeSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(rid of displayedRids | paginate: paginationModel; track trackByRidId($index, rid)) {
        <tr class="table-active">
          <td>{{rid.id}}</td>
          <td>{{rid.external_id}}</td>
          <td>{{rid.data_source}}</td>
          <td>{{rid.market_context}}</td>
          <td>{{rid.resource_id}}</td>
          <td>{{rid.sampleRateMin}}</td>
          <td>{{rid.sampleRateMax}}</td>
          <td>{{rid.power_type.itemLabel + ' (' + rid.power_type.siScaleCode + rid.power_type.itemUnit + ') ' + rid.power_type.hertz + 'Hz ' + rid.power_type.voltage + 'V'}}</td>
          <td>{{rid.mrid ? 1 : 0}}</td>
          <td id="updated_by">{{rid.updated_by}}</td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a class="btn btn-default btn-sm" (click)="nextPage(rid.id, '/editRid', router)" name="editRid">Edit</a>
                <button class="btn btn-danger btn-sm" type="button" (click)="delete(rid)">Delete</button>
              </div>
            </td>
          }
        </tr>
      }

      @if(displayedRids.length <= 0 && !isLoading) {
        <tr>
          <td [attr.colspan]="isAdmin ? 11 : 10" style="text-align: center;">No RIDs exist yet.</td>
        </tr>
      }
    </tbody>

    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 11 : 10">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}

